import { readonly as u, ref as f, onBeforeMount as m, onBeforeUnmount as d } from "vue";
import { isBrowser as p, hasInstance as g } from "./highrise630.mjs";
import { on as h, off as k } from "./highrise632.mjs";
const t = f(null);
function c(e) {
  if (e.clientX > 0 || e.clientY > 0)
    t.value = {
      x: e.clientX,
      y: e.clientY
    };
  else {
    const { target: o } = e;
    if (o instanceof Element) {
      const { left: l, top: i, width: s, height: a } = o.getBoundingClientRect();
      l > 0 || i > 0 ? t.value = {
        x: l + s / 2,
        y: i + a / 2
      } : t.value = { x: 0, y: 0 };
    } else
      t.value = null;
  }
}
let n = 0, r = !0;
function B() {
  if (!p)
    return u(f(null));
  n === 0 && h("click", document, c, !0);
  const e = () => {
    n += 1;
  };
  return r && (r = g()) ? (m(e), d(() => {
    n -= 1, n === 0 && k("click", document, c, !0);
  })) : e(), u(t);
}
export {
  B as default
};
